import { useState } from 'react';
import { Text, SecureText } from 'components/Elements';
import { Authorization, ROLES } from 'lib/authorization';
import { cn } from 'utils/cn';
import { UserDetailsDrawer } from './UserDetailsDrawer';
import { SessionsDrawer } from './SessionsDrawer';
import { UserAvatar } from '..';
import { BlockUser } from './BlockUser';
import { BanUser } from './BanUser';

export const UserCard = ({ user, layout = 'grid' }) => {
  const [isUserDrawerOpen, setUserDrawerOpen] = useState(false);
  const [isSessionsDrawerOpen, setSessionsDrawerOpen] = useState(false);

  const {
    id,
    firstName,
    middleName,
    lastName,
    email,
    photo,
    wallets = [],
  } = user;

  const name = `${firstName} ${middleName || ''} ${lastName}`;
  const defaultWallet = wallets[0];
  const country = defaultWallet?.currency?.country || 'Unknown';
  const flagCode = defaultWallet?.currency?.flagCode?.toLowerCase();

  return (
    <>
      <div
        className={cn(
          'w-full rounded-3xl border border-white/10 bg-white/5 text-white shadow-sm backdrop-blur-md p-4 transition-all hover:shadow-lg',
          layout === 'list'
            ? 'flex items-center justify-between gap-4'
            : 'flex flex-col'
        )}
      >
        {/* Top Row: Avatar + Name */}
        <button
          onClick={() => setUserDrawerOpen(true)}
          className={cn(
            'w-full text-left',
            layout === 'list'
              ? 'flex flex-row items-center justify-between gap-24'
              : 'flex flex-row justify-between items-start'
          )}
        >
          <div
            className={cn(
              'flex items-center gap-4',
              layout === 'list' ? 'flex-1' : 'mb-3'
            )}
          >
            <UserAvatar userId={id} />
            <div>
              <Text variant="body" className="font-semibold text-start">
                {name}
              </Text>

              <div className="overflow-hidden">
                <SecureText
                  className="text-xs"
                  value={email}
                  allowedRoles={[ROLES.ROOT_USER]}
                />
              </div>
            </div>
          </div>

          {flagCode && (
            <div className="flex items-center justify-end gap-2 text-xs text-white/80 mt-1">
              <img
                src={`https://flagcdn.com/h20/${flagCode}.png`}
                alt={country}
                className="w-8 h-8 rounded-full"
              />
            </div>
          )}
        </button>

        {/* Admin Actions */}
        <Authorization allowedRoles={[ROLES.ROOT_USER]}>
          <div
            className={cn(
              'flex gap-2 mt-4',
              layout === 'list' ? 'justify-end' : 'justify-start'
            )}
          >
            <BlockUser id={id} userName={name} />
            <BanUser id={id} userName={name} />
            <button
              onClick={() => setSessionsDrawerOpen(true)}
              className="text-xs px-3 py-1 border border-white/10 rounded-md hover:bg-white/10"
            >
              Sessions
            </button>
          </div>
        </Authorization>
      </div>

      <UserDetailsDrawer
        isOpen={isUserDrawerOpen}
        onClose={() => setUserDrawerOpen(false)}
        id={id}
      />

      <SessionsDrawer
        isOpen={isSessionsDrawerOpen}
        onClose={() => setSessionsDrawerOpen(false)}
        userId={id}
        userName={name}
      />
    </>
  );
};
